const google_recaptcha_scope_name = "google_recaptcha_scope"
const googleRecaptchaWidgetPool = {}

/**
 * 引入GoogleRecaptcha功能
 */
function initGoogleRecaptcha() {
    // call google recaptcha api
    if(document.querySelectorAll("head script[src='" + process.env.VUE_APP_AUTH_RECAPTCHA_GOOGLE_API + "']").length <= 0) {
        let googleRecaptcha = document.createElement("script");
        googleRecaptcha.setAttribute("src", process.env.VUE_APP_AUTH_RECAPTCHA_GOOGLE_API);
        document.head.appendChild(googleRecaptcha);
    }

    // create google recaptcha scope element
    const divEle = document.createElement("div")
    divEle["id"] = google_recaptcha_scope_name
    divEle.setAttribute("style", "display: none;")
    document.body.appendChild(divEle)
}

/**
 * DOM渲染Google Recaptch驗證機制相關資料
 * @param {*} callback 
 */
function genGoogleRecaptchaWidget(name, callback) {
    // create and append button element
    const buttonEleName = name + "_Btn"
    const buttonEle = document.createElement("button")
    buttonEle["id"] = buttonEleName
    document.querySelector("#" + google_recaptcha_scope_name).appendChild(buttonEle)

    return grecaptcha.render(buttonEleName, {
        sitekey: process.env.VUE_APP_AUTH_RECAPTCHA_GOOGLE_SITEKEY,
        //size: 'invisible',
        callback: callback
    })
}

/**
 * 啟動Google Recaptch驗證機制，驗證後執行callback
 * @param {*} callback 
 */
function startGoogleRecaptchaVerify(googleRecaptchaWidgetName, callback) {
    let googleRecaptchaWidget = null
    if(googleRecaptchaWidgetPool[googleRecaptchaWidgetName] == null) {
        googleRecaptchaWidget = genGoogleRecaptchaWidget(googleRecaptchaWidgetName, callback);
        googleRecaptchaWidgetPool[googleRecaptchaWidgetName] = googleRecaptchaWidget
    }
    else {
        googleRecaptchaWidget = googleRecaptchaWidgetPool[googleRecaptchaWidgetName]
        grecaptcha.reset(googleRecaptchaWidget);
    }
    grecaptcha.execute(googleRecaptchaWidget);
}

export default {
    // Google
    initGoogleRecaptcha,
    startGoogleRecaptchaVerify,
}